import axiosConfig from "../utils/axiosConfigInstance";


export const addReactionApi = async (userId, videoId, reaction, type, feedback = '') => {
  try {
    const response = await axiosConfig.post(`${import.meta.env.VITE_APP_API_URL}/reaction`, {
      userId,
      videoId,
      reaction,
      type,
      feedback
    });
    return response.data;
  } catch (err) {
    console.error("API Error:", err);
    throw err;
  }
};


export const getUserReactionsApi = async (userId) => {
  const response = await axiosConfig.get(`${import.meta.env.VITE_APP_API_URL}/reaction/${userId}`);
  return response.data;
};

export const reactionApis = { addReactionApi, getUserReactionsApi };